<template>
    <div style="width: 740px;margin: 0 auto;border:1px solid;box-shadow: 5px 5px 5px #888888;">
        <div id="content" style="width: 640px;margin: 0 auto;">
            <p style="margin:6pt 0pt 0pt; text-align:justify">
                <span style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:right; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">合同编号：</span>
                <my-content v-model="contract.code" :val="contract.code"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"> </span>
            </p>
            <p style="margin:6pt 0pt; orphans:0; text-align:center; widows:0"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:楷体; font-size:24pt; font-weight:bold">服务协议</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:楷体; font-size:14pt; font-weight:bold">天津果敢时代</span><span
                    style="font-family:楷体; font-size:14pt; font-weight:bold">国际贸易有限公司</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:14pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:楷体; font-size:18pt; font-weight:bold">与</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:14pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center">
                <my-content v-model="contract.name" :val="contract.name"></my-content>
            </p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:6pt 0pt 0pt; text-align:center">
                <my-content v-model="contract.year" :val="contract.year"></my-content>
                <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">年</span>
                <my-content v-model="contract.month" :val="contract.month"></my-content>
                <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">月</span>
                <my-content v-model="contract.day" :val="contract.day"></my-content>
                <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">日</span>
            </p>
            <br style="clear:both; mso-break-type:section-break; page-break-before:always"/>
            <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
                    style="font-family:楷体; font-size:16pt; font-weight:bold">服务协议</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify">
                <span style="font-family:楷体; font-size:10.5pt">本《服务协议》（以下简称“<b>本协议</b>”）由以下双方在北京市朝阳区签署：</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:楷体; font-size:10.5pt; font-weight:normal">甲方：</span><span
                    style="font-family:楷体; font-size:10.5pt; font-weight:bold">天津果敢时代国际贸易有限公司</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span></p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span
                style="font-family:楷体; font-size:10.5pt; font-weight:normal">乙方：</span>
                <my-content v-model="contract.Bname" :val="contract.Bname"></my-content>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span
                style="font-family:楷体; font-size:10.5pt">甲方和乙方以下单称为“<b>一方</b>”，合称为“<b>双方</b>”。</span></p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt; text-align:justify">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">鉴于：</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt 28.35pt; text-align:justify; text-indent:-28.35pt">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:normal">A</span>
                <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span style="font-family:华文楷体; font-size:10.5pt">甲方及其关联公司是“大V店”电子商务平台、移动客户端及其他分销平台（“<b>大V店平台</b>”）的所有者和平台服务提供者。</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt 28.35pt; text-align:justify; text-indent:-28.35pt">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:normal">B</span>
                <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span style="font-family:华文楷体; font-size:10.5pt">乙方同意按照本协议的约定，在大V店平台上推广销售其商品或服务（包括但不限于发布商品或服务信息、与消费者达成交易、完成商品配送或以约定方式提供服务等）。</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:楷体; font-size:10.5pt">双方经友好协商，达成协议内容如下：</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <ol type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">资质审核</span>
                    <p style="margin:0pt; text-align:justify">
                        <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist1" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方根据大V店平台公示的《大V店平台商家入驻规则》和《招商标准》提交在大V店平台开展经营活动的必要信息和资质文件（具体内容详见</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件一《乙方资质证明文件清单》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">）。甲方仅在乙方符合甲方要求的商品品牌、类目和经营范围内许可乙方使用甲方服务。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方如变更所提交信息和资质文件，或新增商品品牌、类目或服务内容，应即时通知甲方并更新或补充相应信息和有效的资质文件，否则甲方有权拒绝继续提供服务。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方保证其信息和资质文件的真实性和有效性，并确保所提交信息和资质文件在乙方使用大V店平台服务期间均符合甲方不时修订并公示的《大V店平台商家入驻规则》和《招商标准》。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">大V店平台服务</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist2" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">平台技术服务<br>甲方为乙方消费者提供交易平台，同时为乙方提供与大V店平台服务相关的技术服务，包括但不限于商品（服务）信息发布、平台内信息检索、订单管理、款项支付等技术服务。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">代收款服务<br>乙方同意，消费者在大V店平台购买乙方商品或服务应支付的款项，由乙方委托甲方代为收取。消费者按照大V店平台交易规则将相关款项通过各类支付渠道（包括但不限于网上银行、第三方支付机构等支付方式）支付至甲方收款账户，甲乙双方按照本协议约定进行款项结算。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">其他服务<br>甲方有权根据乙方请求自行决定为乙方提供市场营销服务、仓储物流服务、客户服务、金融服务等增项服务，届时双方将另行签署协议或以其他书面方式确认。甲方有权随时对甲方平台的相关服务和功能进行变更、升级和完善，有权定期或不定期对甲方平台进行系统维护、开发新的模块、功能和软件。除非甲方在本协议中另有说明，否则变更后的服务仍应适用于本协议。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">大V店平台规则</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist3" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方使用大V店平台服务，同意遵守甲方制订并在大V店平台公示的《大V店平台商家入驻规则》及其他商家规范（“<b>大V店平台规则</b>”），大V店平台规则作为对本协议双方权利义务的补充，构成本协议的一部分。甲方有权根据需要不时制订或修改大V店平台规则，并在大V店平台上更新公示。乙方如不同意相关规则变更，须立即以正式书面方式告知甲方，甲方有权选择是否对乙方适用该规则变更或立即与乙方解约。如乙方继续使用大V店平台服务，视为乙方对大V店平台规则的无条件接受。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品销售</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist4" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方通过大V店平台向消费者销售商品或服务。乙方商品或服务应符合国家法律法规规定、大V店平台规则和《招商标准》。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应将其所销售商品或服务的图片、文字等信息按照甲方要求，上传至大V店平台。乙方自行负责相关信息日常在线的维护，包括但不限于在售商品增减、商品信息调整、商品价格调整、日常客户服务等。乙方的维护内容需要甲方确认后方能在前端呈现。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方通过大V店平台推广销售商品或服务，应严格遵守国家有关产品质量责任、消费者权益保护、广告发布和促销行为等法律法规的相关规定。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品交付</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist5" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">消费者在大V店平台提交订单并全额支付订单款项后【48】小时内，乙方负责将消费者购买的有关商品按照订单载明地址信息交付配送商，并通过大V店平台上传发货信息（包括但不限于配送方名称、配送单号信息等）。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应按甲方要求对商品进行二次包装，在包装中附带甲方要求的材料，包括但不限于发货单、商品发票等，但不得夹带任何未经甲方许可的资料、宣传单等资料。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方在配送过程中产生的包装费用、物流配送费用等均由乙方自行承担。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品定价</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist6" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方商品的销售价格由乙方自主决定，但乙方同意，甲方对乙方的价格有审核的权利。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方确认，乙方在大V店平台呈现的商品销售价格应为含税价格，且已包含乙方就该商品销售所提供的配送、售后服务等全部费用。乙方不得在向消费者配送商品或提供其他服务的过程中收取任何其他费用。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品质量</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist7" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方向消费者配送的商品（包含赠品）应为其合法生产或有权经销的、符合国家质量标准或行业标准及双方约定的标准的、全新且未曾在其他渠道销售过的商品，该等商品不存在侵犯任何第三方权益的情况。该等商品质量应符合大V店平台规则的相关要求。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">商品质量应符合下列要求：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）商品不存在危及人身、财产安全的危险，符合保障人体健康和人身、财产安全的相关国家、行业标准；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）具备商品应当具备的使用性能，对商品存在使用性能的瑕疵已作出说明；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）符合在商品或者其包装上注明采用的商品标准，与广告、商品说明、实物样品表明的质量状况相符合；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）食品（包括成分及用量）需符合我国食品安全法及相关法律法规的标准和要求；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）其他特殊产品质量的国家标准。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">商品或者商品包装上的标识真实，并符合下列要求：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）有产品质量检验合格证明；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）商品应当按照法律法规的要求贴注条形码及中文标识，有中文标明的产品名称、成分及用量规格、等级、有效期、生产厂厂名和厂址等信息；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）限期使用的商品，在显著位置标明生产日期和安全使用期或失效日期；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）商品成分说明或原料表中对于特殊成分应当予以相应的说明；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）使用不当容易造成商品本身损坏或者可能危及人身、财产安全的商品，有警示标志。其他需要事先让消费者知晓的事项，在外包装上标明，或者预先向消费者提供有关资料；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（6）其他关于产品包装标识的国家标准要求。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方保证不存在以下欺诈行为：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）在商品中掺杂、掺假、以假充真、以次充好或以不合格产品冒充合格产品；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）供应国家明令淘汰的产品或者失效、变质的商品；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）伪造商品的产地，伪造或者冒用他人的厂名、厂址，伪造或者冒用认证标志、名优标志等质量标志；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）依法需强制检验或认证的，未履行检验或认证手续或者伪造检验或认证结果；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）配送的商品中出现已拆封的商品或“空盒”商品（含缺少配件、说明书等随机附件）；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（6）乙方向消费者提供有关商品或者服务的信息不真实，存在引人误解的虚假宣传，发布虚假广告或者欺骗、误导消费者，使购买商品或者接受服务的消费者的合法权益受到损害；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（7）其他国家法律法规明文禁止的欺诈行为。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方提供的所有商品清洁整齐，包装完好，适宜销售，配送时包装不得出现任何污损。凡有保质期的商品如果保质期大于六个月的，乙方商品送达消费者订单指定收货地时其商品保质期距到期日的时限不得少于保质期规定的一半；如果商品保质期小于六个月，乙方商品送达消费者订单指定收货地时则不应少于其保质期的三分之二。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方提供商品不符合国家法律法规相关规定和前述商品质量要求，即视为不合格商品，消费者有权要求退款退货。乙方应当按照大V店平台的退货政策和流程为消费者办理退货。退货过程中产生的运输费用由乙方承担。如因乙方前述行为造成甲方或消费者任何损害（包括人身和财产损失）的，乙方应当承担全部赔偿责任。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">如乙方销售商品或服务存在下述情形的：销售国家禁止流通，限制流通商品；提供非法服务；未经授权销售，销售侵权、假冒伪劣或有其他问题的商品；宣传图片或商品信息等违法侵权；其他甲方认为不宜继续销售的情形，甲方可对该商品进行即时下架处理，并通知乙方提供相关相反证据，包括但不限于合法授权销售证明，乙方应立即提交。若乙方不能提供或经查前述情形属实的，甲方有权采取下列一项或多项措施：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）要求乙方承担大V店平台规则规定的惩罚金；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）要求乙方支付本协议生效到上述行为发生时为止乙方通过甲方销售商品总金额的10%作为违约金；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）要求乙方赔偿甲方因此遭受的全部损失；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）解除本协议。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">如因乙方提供商品存在瑕疵危及人身财产安全，或因涉及重大安全问题危及甲方名誉受损，或引起或可能引起较大规模投诉、举报或诉讼，甲方有权要求召回有关商品，乙方应按甲方要求在大V店平台或甲方指定其他媒介发布有关商品的召回信息，完成对召回商品的退货、换货、维修，并承担由此产生的所有费用。乙方同时应赔偿因此造成甲方及消费者的任何损失。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">售后服务</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist8" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应根据国家法律法规、本协议约定、大V店平台规则及相关政策规定，为消费者提供乙方商品的“退货、换货、维修”等售后服务，包括但不限于：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）如消费者在收到商品前申请取消订单或拒绝签收商品，乙方同意甲方取消该笔订单并退还货款。该笔订单商品由乙方收回，因此产生的一切费用由乙方自行承担；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）如消费者在收到乙方所售商品之日起【15】日内要求无条件退换货的，乙方同意甲方接受退换货申请，并在乙方收到消费者退回商品后办理相应手续，因退换货产生的配送费用甲方应告知申请的消费者自行承担；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）如消费者在收到乙方所售商品后因商品违法、侵权、质量问题等要求退换货，乙方同意甲方接受退换货申请，并在收到消费者退回的商品后办理相应手续，因退换货产生的全部费用由乙方承担；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）如消费者要求维修商品，乙方应在收到消费者退回商品后的【30】日内将破损商品修复至令消费者满意且能合理使用的程度后重新配送给消费者；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）如消费者因乙方销售商品违法、侵权、质量问题等投诉、举报或提起诉讼，乙方负责处理解决并承担全部费用，保护甲方免予承担因此而产生的任何法律责任（包括任何赔偿或处罚）或声誉受损。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">先行赔付<br>乙方了解并同意，如乙方未适当履行本协议规定的售后服务或未适当处理消费者投诉、举报或诉讼，甲方有权根据国家法律法规、本协议、大V店平台规则及相关政策规定，判断乙方是否应履行退款或赔付义务。如判定乙方应对消费者进行退款、支付违约金和/或赔偿款，甲方有权从乙方保证金（见下文定义）中直接划扣相应金额支付给消费者，然后向乙方追偿或从任何甲方应付乙方款项中扣除。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">客户服务</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）乙方应指派专人负责处理消费者提交或甲方转交的客户服务问题（统称“工单”），并将服务电话（内部接口专用）及工作邮件（内部接口专用）提供至甲方。乙方应在【24】小时内回复客服问题，同时乙方官方渠道（包括但不限于平台账号、网站、微博、微信等）应当对客户提问在24小时内予以反馈回复。对于超时回复，甲方有权按照大V店平台规则扣除乙方保证金；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）乙方回复内容中应包含对于该问题的解释、明确处理方案及事件说明，不能出现“正在查询/正在沟通”等无实质解决方案的回复，否则即视为延迟回复，具体以甲方的认定为准；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）乙方客服负责人联系方式如下，如有变更乙方应及时通知甲方，否则所产生的一切损失由乙方承担；</span>
                            </p>
                            <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt;">联系人：</span>
                                <my-content v-model="contract.BcontactsName" :val="contract.BcontactsName"></my-content>
                            </p>
                            <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt;">职务：</span>
                                <my-content v-model="contract.BcontactsPost" :val="contract.BcontactsPost"></my-content>
                            </p>
                            <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt;">电话：</span>
                                <my-content v-model="contract.BcontactsTel" :val="contract.BcontactsTel"></my-content>
                            </p>
                            <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt;">手机：</span>
                                <my-content v-model="contract.BcontactsPhone" :val="contract.BcontactsPhone"></my-content>
                            </p>
                            <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt;">邮箱：</span>
                                <my-content v-model="contract.BcontactsEmail" :val="contract.BcontactsEmail"></my-content>
                            </p>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">服务费及货款结算</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist9" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应就本协议项下甲方及甲方平台卖家向乙方提供的服务向甲方及甲方平台卖家支付服务费。商品类别及服务费标准见<b>附件二《大V店平台商品类别及服务费标准》、附件三《大V店平台卖家商品类别及服务费标准》</b>。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                        结算周期：甲乙双方同意就每30天期间交易完成订单的商品货款及服务费于期间届满后【5】日内进行对账工作。双方数据核对一致后，甲方就上述商品实际交易货款扣除甲方服务费、甲方平台卖家服务费及其他依据本协议、本协议附件及大V店平台规则应扣除费用后的款项余额与乙方结算。结算货币为人民币。
                    </span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">除非另有其他书面约定，甲方通过银行转账或电汇方式向乙方下述银行账号付款：</span>
                            <p style="margin: 0pt 0pt 0pt 4pt;text-indent: -1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">收款方名称：</span>
                                <my-content v-model="contract.collectName" :val="contract.collectName"></my-content>
                            </p>
                            <p style="margin: 0pt 0pt 0pt 4pt;text-indent: -1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">税务登记号：</span>
                                <my-content v-model="contract.taxNum" :val="contract.taxNum"></my-content>
                            </p>
                            <p style="margin: 0pt 0pt 0pt 4pt;text-indent: -1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">开户银行：</span>
                                <my-content v-model="contract.bankName" :val="contract.bankName"></my-content>
                            </p>
                            <p style="margin: 0pt 0pt 0pt 4pt;text-indent: -1pt;">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">账号：</span>
                                <my-content v-model="contract.bankNum" :val="contract.bankNum"></my-content>
                            </p>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方如需修改付款信息，应提前在对账结束前书面通知甲方。如乙方未能在上述期限内通知甲方，则乙方应承担甲方根据未修改的付款信息向乙方进行付款所发生的一切后果。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">对于乙方自甲方获取的任何补贴收入，包括但不限于各类优惠券、代金券、现金抵用券补贴，乙方应根据甲方要求向甲方开具合法有效的发票。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议终止时（无论任何原因），甲方有权继续留存最后一期应付乙方款项【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲乙双方可就最后一期应付乙方款项进行结算。否则，甲方有权直接从最后一笔结算款项中扣除对应款项，最后一笔结算款项不足以弥补甲方损失部分，或不足以支付各项费用及欠款，乙方应继续承担相应赔偿责任。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">保证金</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist10" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方同意向甲方指定账户缴存一定金额（“保证金”）用于担保其对本协议的履行和遵守。乙方应当在签订本协议后【10】日内向甲方支付总计人民币【10000】元的保证金。 甲方有权根据乙方经营情况随时调整保证金额度。 如本协议为续签协议，甲乙双方同意，乙方根据双方签署的原《技术服务协议》及与其项下附件、补充协议（“原协议”）缴存的保证金余额继续适用于本协议。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                       如乙方保证金额度调整或出现任何保证金被扣减情形，导致乙方保证金不足约定金额时，乙方同意甲方自应付乙方的任何款项中直接扣除差额，如甲方应付乙方款项不足弥补保证金差额，乙方应当于收到甲方通知之日起【10】日内将保证金补足。
                    </span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方保证金银行账户信息如下：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-11pt">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">户名：【天津果敢时代国际贸易有限公司】</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-11pt">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">开户行：【招商银行股份有限公司天津武清支行】</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-11pt">
                                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">账号：【122907366910806】</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方可在以下情形发生时，处置保证金：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）如乙方违反国家法律法规、本协议、大V店平台规则或其他政策规定，应向消费者退还货款、支付违约金和/或赔偿款的，甲方有权直接划扣保证金用于代乙方向消费者退还货款、支付违约金和/或赔偿款；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）如乙方违反国家法律法规、本协议、大V店平台规则或其他政策规定，致使甲方及/或其关联公司权益受损（包括但不限于被行政处罚、被判决侵权、商誉受损等），甲方有权划扣保证金中的相应金额至甲方账户作为违约金和/或赔偿款；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）如乙方违反本协议或大V店平台规则，根据本协议或大V店平台规则应当向甲方支付惩罚金、违约金和/或赔偿款，甲方有权划扣保证金中的相应金额至甲方账户作为惩罚金、违约金和/或赔偿款；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）如乙方违反其与甲方或其关联公司的其他协议规定造成甲方或其关联公司损失或应支付违约金，乙方同意甲方可基于该协议规定直接划扣保证金中的相应金额；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）其他甲方有合法合理理由可处置保证金的情况。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议履行期间，保证金的支配、使用权均归属于甲方。在乙方解散、清算、破产时，甲方享有对保证金的优先受偿权。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议终止时（无论任何原因），甲方有权继续留存保证金【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲方将保证金余额无息退还乙方。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">知识产权</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist11" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">与商品相关的专利、商标、名称、特有标识、装潢、技术秘密等均属于其权利人所有。乙方保证其已按照法律规定或者合同约定获得了通过大V店平台销售商品或服务的权利或许可，该等权利或许可不与任何排他性权利相冲突，否则乙方应赔偿甲方因此而产生的任何经济损失。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                       乙方在此不可撤销地免费授权甲方 (并许可甲方对该权利进行再授权)，以推广乙方商品为目的，全部或部分地摘录、改编、翻译、复制、发布、展示或以其它任何合理方式使用乙方提供给甲方或其在大V店平台展示的任何信息和资料（包括但不限于商品商标、logo、商品信息、宣传资料、订单信息等)。
                    </span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">乙方保证和承诺</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist12" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">除严格遵守本协议和大V店平台规则其它规定外，乙方保证和承诺：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）乙方具有签订和履行本协议所需的所有合法资格、资质和能力，包括应持有中国法律法规所要求的一切证明、批准、许可和其他任何证明文件，而且应为商品的生产商或授权经销商；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）乙方在大V店平台销售的商品来源正当合法，均为全新正品行货；乙方对其所销售商品享有唯一的合法的所有权，并且商品在本协议项下的推广和销售未侵犯任何第三方的权利，包括但不限于第三方的知识产权；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）乙方在大V店平台上销售的同款商品的销售价格不高于其提供给任何其他渠道或采购方的价格；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）乙方（第三方商家）自主决定是否就其所销售商品在甲方平台发布广告及广告的内容和形式，保证广告真实、合法，并承担因广告引起的全部法律责任；甲方仅对乙方上传的商品信息进行审核，不对广告进行审核，也不对广告承担法律责任；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）乙方在使用大V店平台服务的过程中遵守诚实信用原则，不在交易过程中采取虚假宣传等不正当竞争行为，不扰乱网上交易的正常秩序，不从事与网上交易无关的行为；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（6）乙方维护甲方及甲方平台的良好声誉和形象，不会作出任何有损甲方品牌形象和良好声誉的言论及行动，否则甲方有权拒绝履行本协议，并要求乙方采取补救措施。若发现乙方故意诋毁或损害甲方声誉的情形，甲方有权立即终止本协议，并追究乙方违约责任。</span>
                            </p>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">甲方免责</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist13" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">不论在何种情况下，甲方均不对由于网络连接故障、计算机系统故障、通讯故障、电力故障、电脑病毒、黑客入侵、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争等不可抗力事件而造成的不能服务或延迟服务承担责任。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">大V店平台仅作为乙方寻找交易对象，就商品和服务的交易进行协商以及获取各类与交易相关服务的平台。本协议的签署并不意味着甲方成为乙方在大V店平台上与第三方所进行交易的参与者。甲方仅对乙方于消费者的交易行为提供技术服务，不对乙方行为的合法性、有效性及商品的真实性、合法性和有效性作任何明示或暗示的担保。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">保密和知识产权</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist14" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">任何一方均应对本协议内容，以及依据本协议而获得的对方的保密或专有信息（包括但不限于，与对方的技术、客户、商业计划、营销活动和财务有关的所有信息）（ “<b>保密信息</b>”）严格保密，并且不得用于本协议以外目的，否则应对因此给对方造成的损失承担赔偿责任。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">未经甲方及/或其关联公司同意，乙方不得使用甲方及/或其关联公司的任何商标、服务标识、品牌或其他知识产权，不得发布有关甲方及/或其关联公司或者本合同的任何新闻稿或其他公开文件，或在任何宣传资料中提及甲方及/或其他关联公司。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">不可抗力</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist15" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">由于不能预见、不能避免、不能克服的客观原因，包括但不限于地震、台风、海啸等自然灾害，政治动荡、暴动、战争、政府行为，以及通讯或其他设施故障等，导致一方无法履行本协议项下义务，不承担违约责任。前提是，该方已经及时以适当的方式向另一方告知该不可抗力事件的发生并提供相关证明材料。并且在不可抗力事件的影响消失后，应当立即恢复履行合同。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">期限和终止</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist16" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt -10.35pt; text-indent:0pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议有效期限为自签署之日起至</span>
                            <my-content v-model="contract.endYear" :val="contract.endYear"></my-content><span
                                style="font-family:华文楷体; font-size:10.5pt">年</span>
                            <my-content v-model="contract.endMonth" :val="contract.endMonth"></my-content><span
                                style="font-family:华文楷体; font-size:10.5pt">月</span>
                            <my-content v-model="contract.endDay" :val="contract.endDay"></my-content><span
                                style="font-family:华文楷体; font-size:10.5pt">日</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">任何一方可在另一方严重违反本协议（包括本协议附件、大V店平台规则等）且收到守约方书面通知后十五(15)个工作日内未予以纠正时，书面通知另一方，立即终止本协议；任何一方可以经提前六十天向另一方发出书面通知而无因终止协议，前提是乙方已经履行完毕其在本协议终止前已接受的订单。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">协议终止后续事项的处理</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）自本协议终止之日起，甲方将乙方商品和服务内容全部下架并进行清算，乙方不得再通过该账户进行任何形式的操作。如果乙方在商品下架后再次上架进行销售，且有消费者提交订单并进行支付，乙方应当按照本协议要求对相关商品进行配送，由此产生的货款，甲方有权不予结算；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）本协议终止后，甲方有权保留乙方的注册信息及交易行为记录等数据，但甲方没有为乙方保留这些数据的义务，亦不承担在协议终止后向乙方或第三方转发任何未阅读或未发送的信息的义务，也不就协议终止向乙方或任何第三方承担责任，但法律另有规定的除外；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）本协议终止并不免除乙方依据本协议应向客户承担的商品质量责任和售后服务义务；如本协议终止后，因乙方商品质量问题或售后服务问题而导致甲方或其他任何第三方人身或财产损失的，乙方仍应承担全部赔偿责任。</span>
                            </p>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">违约责任</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist17" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议履行过程中，乙方如违反国家法律法规、本协议、大V店平台规则或其他政策任何规定，或侵犯任何第三方（包括但不限于消费者、知识产权权利人或商品/服务的实际使用者）合法权益，除根据本协议和/或大V店平台规则向甲方支付惩罚金、违约金外，还应赔偿甲方因此遭受的全部损失，包括但不限于：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）甲方被判决须向任何第三方支付的违约金或赔偿额；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）甲方被执行行政处罚的金额；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）甲方代乙方向消费者支付的退款、违约金或赔偿额；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）甲方支付的合理律师费用、消除影响所支出的必要费用。</span>
                            </p>
                            <span style="font-family:华文楷体; font-size:10.5pt">同时，乙方还应当按照甲方的要求，采取措施以停止侵害、恢复名誉、消除影响等。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议履行过程中，乙方保证乙方股东、实际控制人、董事、经理、业务负责人、雇员、代理人、受托人等（以下称“乙方代表”）均严格履行本协议规定，并遵守大V店平台所公示的各项准则，乙方代表违反本协议任何内容的行为视为乙方违约行为，乙方应对此承担全部法律责任。</span>
                        </li>
                    </ol>
                </li>
                <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
                    <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">其他</span>
                    <p style="margin:0pt; text-align:justify"><span
                            style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
                    </p>
                    <ol type="1" class="awlist18" style="margin-left:-17pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议受中华人民共和国法律管辖。对于因本协议而产生的任何争议，双方均应努力通过友好协商的方式进行解决。如无法就争议解决达成一致，任何一方均可向合同签订地人民法院提起诉讼。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议一方未经另一方事先书面同意不得将其本协议项下的权利和义务全部或部分转让给任何第三方。尽管有前述规定，乙方同意，甲方可将本协议（或其在本协议项下的任何权利或义务）转让给其关联公司，或当发生合并、重组、出售全部或重要资产或类似交易时转让给其后续公司。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议无论因任何原因终止，除协议中已有规定外，商品质量、售后服务、知识产权、保密、保证和承诺、违约责任条款在协议终止后将继续有效。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">除非本协议另有规定或双方另有约定，甲乙双方就本协议所作的通知及其他通信，均需通过书面形式送达。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议未尽事宜，甲乙双方另行签订书面补充协议。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议内容包括协议正文、附件、补充协议（如有）以及甲方不时修订的大V店平台规则。任何对本协议或大V店平台规则的修订一经生效即构成协议各方权利义务的补充，并成为本协议的一部分。本协议经双方授权代表签署并加盖双方公章或合同章后生效。本协议一式贰（2）份，甲乙双方各执壹（1）份，具有同等效力。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方在本协议生效前签订的协议在本协议生效后即时终止。未完成事项可由双方参考本协议约定事项进行处理。</span>
                        </li>
                    </ol>
                </li>
            </ol>


            <p style="margin:7.8pt 0pt 0pt; text-align:center">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">&nbsp;</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:center">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">[以下无正文]</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">&nbsp;</span></p>
            <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">&nbsp;</span></p>
            <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:464.3pt">
                <tr style="height:96.8pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:264pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">甲方（盖章）：</span>
                            <span style="font-family:楷体; font-size:10.5pt">天津果敢时代国际贸易有限公司</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期:</span>
                            <my-content v-model="contract.AsignYear" :val="contract.AsignYear"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <my-content v-model="contract.AsignMonth" :val="contract.AsignMonth"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <my-content v-model="contract.AsignDay" :val="contract.AsignDay"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:200pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">乙方（盖章）：</span>
                            <my-content v-model="contract.Bsign" :val="contract.Bsign"></my-content>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0"><span
                                style="font-family:楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0"><span
                                style="font-family:楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0"><span
                                style="font-family:楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <my-content v-model="contract.BsignYear" :val="contract.BsignYear"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <my-content v-model="contract.BsignMonth" :val="contract.BsignMonth"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <my-content v-model="contract.BsignDay" :val="contract.BsignDay"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <my-content v-model="contract.Adeputy" :val="contract.Adeputy"></my-content>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <my-content v-model="contract.Bdeputy" :val="contract.Bdeputy"></my-content>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt; text-align:center"><br style="page-break-before:always; clear:both"/>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件一 乙方资质证明文件清单</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <table cellspacing="0" cellpadding="0"
                   style="border-collapse:collapse;float:left; margin:0pt 9pt; width:387.45pt">
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">文件名称</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">资质要求及涉及类别</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top;">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">1.</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                    <td colspan="4" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">基本资质证件</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.1</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">营业执照副本</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt;">
                        <p style="margin:0pt;orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">必须具有独立法人资格；如为分支机构，不具有独立法人资格，需提供总公司授权书；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.2</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">法定代表人身份证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内，正反面复印；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.3</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">税务登记证（三证合一后无需提供）</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.4</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">组织机构代码证（三证合一后无需提供）</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.5</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">一般纳税人认定证书</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.6</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">开户银行许可证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.7</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">商标注册证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.8</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">品牌授权销售代理协议或证明</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">如为品牌代理商，须提供生产商、品牌商或商标专有权人授权销售证明文件</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.9</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进口货物报关单</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">海关出具的注有进口数量、成交总价的凭证</span>
                        </p>
                    </td>
                </tr>

                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top;">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">2.</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                    <td colspan="4" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">特许经营资质文件</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.1</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt;">
                        <p style="margin:0pt;orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">食品</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.2</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证、保健食品批准证书以及保健食品生产企业批准证书、进口保健食品批准证书（如为进口保健食品）</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">保健食品</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.3</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">出版物经营许可证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">出版物、音像制品、电子出版物</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.4</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">医疗器械经营许可证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">第二类医疗器械</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.5</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">批次化妆品检验报告；特殊用途化妆品卫生批准文件（如为特殊用途化妆品）；生产厂家卫生许可证复印件以及生产厂家生产许可证复印件</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">国产化妆品</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.6</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进口化妆品卫生许可批件；进口化妆品厂家检验报告；进口检验检疫部门检验报告以及标签审核证书</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进口化妆品</span>
                        </p>
                    </td>
                </tr>

            </table>
            <p style="margin:7.8pt 0pt 0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:7.8pt 0pt 0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:0pt"><br style="page-break-before:always; clear:both"/></p>
            <p style="margin:7.8pt 0pt 0pt; text-align:center">
                <span style="font-family:楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件二：《大V店平台商品类别及服务费标准》</span>
                <el-button type="text" @click="addDomain(0)">添加</el-button>
            </p>
            <p style="background-color:#ffffff; line-height:15.75pt; margin:0pt; text-align:justify">
                <span style="font-family:Calibri; font-size:10.5pt">&nbsp;</span>
            </p>

            <el-table :data="contract.goodsStandard1" border style="width: 100%;margin: 0 auto;">
                <el-table-column label="商品名称" align="center">
                    <template scope="scope">
                        <my-content v-model="scope.row.category" :val="scope.row.category"></my-content>
                        <!--<span>{{ scope.row.goodsName }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column label="品牌" align="center">
                    <template scope="scope">
                        <my-content v-model="scope.row.brand" :val="scope.row.brand"></my-content>
                        <!--<span>{{ scope.row.goodsUnit }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column label="固定比例（%/单）" align="center">
                    <template scope="scope">
                        <my-content v-model="scope.row.ratio" :val="scope.row.ratio"></my-content>
                        <!--<span>{{ scope.row.goodsNumber }}</span>-->
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center">
                    <template scope="scope">
                        <el-button size="small" type="primary" @click.prevent="removeDelete(0,scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <p style="background-color:#ffffff; line-height:15.75pt; margin:0pt; text-align:justify">
                <span style="font-family:Calibri; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="background-color:#ffffff; line-height:15.75pt; margin:0pt; text-align:justify">
                <span style="font-family:Calibri; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:center">
                <span style="font-family:楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件三：《大V店平台卖家商品类别及服务费标准》</span>
                <el-button type="text" @click="addDomain(1)">添加</el-button>
            </p>

            <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
                    style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span></p>

            <el-table :data="contract.goodsStandard2" border style="width: 100%;margin: 0 auto;">
                <el-table-column label="商品名称" align="center">
                    <template scope="scope">
                        <my-content v-model="scope.row.category" :val="scope.row.category"></my-content>
                        <!--<span>{{ scope.row.goodsName }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column label="品牌" align="center">
                    <template scope="scope">
                        <my-content v-model="scope.row.brand" :val="scope.row.brand"></my-content>
                        <!--<span>{{ scope.row.goodsUnit }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column label="固定比例（%/单）" align="center">
                    <template scope="scope">
                        <my-content v-model="scope.row.ratio" :val="scope.row.ratio"></my-content>
                        <!--<span>{{ scope.row.goodsNumber }}</span>-->
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center">
                    <template scope="scope">
                        <el-button size="small" type="primary" @click.prevent="removeDelete(1,scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <p style="margin:7.8pt 0pt 0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
        </div>
        <div style="padding:20px 0px 15px 0px;text-align: center">
            <el-button type="primary" @click="submitContent()">保 存</el-button>
            <el-button type="primary" @click="findEmpty()">定位未填</el-button>
            <el-button type="primary" @click="returnWindow()">返 回</el-button>
        </div>
    </div>
</template>
<script type="text/javascript">
    export default {
        data () {
            return {
                contract: {

                    code: "",
                    name: "",

                    year: "",
                    month: "",
                    day: "",

                    Bname: "",

                    BcontactsName: "",
                    BcontactsPost: "",
                    BcontactsTel: "",
                    BcontactsPhone: "",
                    BcontactsEmail: "",

                    collectName: "",
                    taxNum: "",
                    bankName: "",
                    bankNum: "",

                    endYear: "",
                    endMonth: "",
                    endDay: "",

                    Bsign: "",

                    AsignYear: "",
                    AsignMonth: "",
                    AsignDay: "",

                    BsignYear: "",
                    BsignMonth: "",
                    BsignDay: "",

                    Adeputy: "",
                    Bdeputy: "",

                    goodsStandard1: [
                        {category: "", brand: "", ratio: ""}
                    ],
                    goodsStandard2: [
                        {category: "", brand: "", ratio: ""}
                    ]
                }
            }
        },
        mounted () {
            var contentId = this.$route.query.contentId;
            var type = this.$route.query.type;
            var templateId = this.$route.query.templateId;

            var isSupplier = this.$route.query.isSupplier;
            this.isSupplier = isSupplier;

            this.type = type;
            this.contentId = contentId;
            this.templateId = templateId;
            this.initContent(contentId, type);
        },
        methods: {
            findEmpty(){
                var el = this.emptyElement(this);
                if(el){
                    el.focus();
                }else{
                    this.$message({
                        message: "已全部填写完毕",
                        type: 'success'
                    });
                }
            },
            emptyElement(object){
                if(object.$children.length > 0 ){
                    for(var key in object.$children){
                        var el = this.emptyElement(object.$children[key]);
                        if(el){
                            return el;
                        }
                    }
                }else{
                    if(object.$options._componentTag === "my-content"
                        && object.$el.innerText == ""){
                        return object.$el;
                    }
                }
                return null;
            },
            isEmpty(value){
                var isEmpty = false;
                if("object" === typeof value){
                    for(var key in value){
                        var empty = this.isEmpty(value[key]);
                        if(empty){
                            return empty;
                        }
                    }
                }else{
                    value = value || "";
                    return value == "" || value == "undefined";
                }
                return isEmpty;
            },
            returnWindow(){
                window.close();
            },
            addDomain(type) {
                if (type==0){
                    this.contract.goodsStandard1.push({
                        category: "",
                        brand: "",
                        ratio: ""
                    });
                } else {
                    this.contract.goodsStandard2.push({
                        category: "",
                        brand: "",
                        ratio: ""
                    });
                }

            },
            removeDelete(type,item) {
                if (type == 0){
                    var index = this.contract.goodsStandard1.indexOf(item)
                    if (index !== -1) {
                        this.contract.goodsStandard1.splice(index, 1)
                    }
                } else {
                    var index = this.contract.goodsStandard2.indexOf(item)
                    if (index !== -1) {
                        this.contract.goodsStandard2.splice(index, 1)
                    }
                }

            },
            submitContent(){
                var that = this;

                //验证信息完整度
                var isEmpty = that.isEmpty(that.contract);

                var data = {
                    templateId: that.templateId,
                    complete:isEmpty ? 0 : 1,
                    content: JSON.stringify(that.contract),
                    type: that.type
                };

                if (that.contentId) {
                    data["contentId"] = that.contentId;
                }

                $.ajax({
                    url: '/suppliers/contract/template/save',
                    data: JSON.stringify(data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            that.contentId = result.data.templateContentId;
                            var templateData = {templateId:that.templateId,contentId:that.contentId};
                            if(!this.isSupplier ||  this.isSupplier !=1){
                                window.opener.eventHub.$emit('SET_CONTENT_ID', templateData);
                            }
                            window.close();
                        }
                    }
                })
            },
            initContent(contentId, type){
                var that = this;
                if (!contentId) {
                    contentId = 0;
                }
                $.get({
                    url: '/suppliers/contract/template/content',
                    data: {
                        contentId: contentId,
                        type: type
                    },
                    success: function (result) {
                        if (!result.code) {
                            if ($.isEmptyObject(result.data)){
                            } else {
                                that.contract = result.data;
                            }
                        } else {

                        }
                    }
                })
            }
        }
    }
</script>
<style type="text/css" lang="less" scoped>
    .awlist1 {
        counter-reset: awlistcounter1;
        list-style-type: none
    }

    .awlist1 li:before {
        content: "1." counter(awlistcounter1);
        counter-increment: awlistcounter1
    }

    .awlist2 {
        counter-reset: awlistcounter2;
        list-style-type: none
    }

    .awlist2 li:before {
        content: "2." counter(awlistcounter2);
        counter-increment: awlistcounter2
    }

    .awlist3 {
        counter-reset: awlistcounter3;
        list-style-type: none
    }

    .awlist3 li:before {
        content: "3." counter(awlistcounter3);
        counter-increment: awlistcounter3
    }

    .awlist4 {
        counter-reset: awlistcounter4;
        list-style-type: none
    }

    .awlist4 li:before {
        content: "4." counter(awlistcounter4);
        counter-increment: awlistcounter4
    }

    .awlist5 {
        counter-reset: awlistcounter5;
        list-style-type: none
    }

    .awlist5 li:before {
        content: "5." counter(awlistcounter5);
        counter-increment: awlistcounter5
    }

    .awlist6 {
        counter-reset: awlistcounter6;
        list-style-type: none
    }

    .awlist6 li:before {
        content: "6." counter(awlistcounter6);
        counter-increment: awlistcounter6
    }

    .awlist7 {
        counter-reset: awlistcounter7;
        list-style-type: none
    }

    .awlist7 li:before {
        content: "7." counter(awlistcounter7);
        counter-increment: awlistcounter7
    }

    .awlist8 {
        counter-reset: awlistcounter8;
        list-style-type: none
    }

    .awlist8 li:before {
        content: "8." counter(awlistcounter8);
        counter-increment: awlistcounter8
    }

    .awlist9 {
        counter-reset: awlistcounter9;
        list-style-type: none
    }

    .awlist9 li:before {
        content: "9." counter(awlistcounter9);
        counter-increment: awlistcounter9
    }

    .awlist10 {
        counter-reset: awlistcounter10;
        list-style-type: none
    }

    .awlist10 li:before {
        content: "10." counter(awlistcounter10);
        counter-increment: awlistcounter10
    }

    .awlist11 {
        counter-reset: awlistcounter11;
        list-style-type: none
    }

    .awlist11 li:before {
        content: "11." counter(awlistcounter11);
        counter-increment: awlistcounter11
    }

    .awlist12 {
        counter-reset: awlistcounter12;
        list-style-type: none
    }

    .awlist12 li:before {
        content: "12." counter(awlistcounter12);
        counter-increment: awlistcounter12
    }

    .awlist13 {
        counter-reset: awlistcounter13;
        list-style-type: none
    }

    .awlist13 li:before {
        content: "13." counter(awlistcounter13);
        counter-increment: awlistcounter13
    }

    .awlist14 {
        counter-reset: awlistcounter14;
        list-style-type: none
    }

    .awlist14 li:before {
        content: "14." counter(awlistcounter14);
        counter-increment: awlistcounter14
    }

    .awlist15 {
        counter-reset: awlistcounter15;
        list-style-type: none
    }

    .awlist15 li:before {
        content: "15." counter(awlistcounter15);
        counter-increment: awlistcounter15
    }

    .awlist16 {
        counter-reset: awlistcounter16;
        list-style-type: none
    }

    .awlist16 li:before {
        content: "16." counter(awlistcounter16);
        counter-increment: awlistcounter16
    }

    .awlist17 {
        counter-reset: awlistcounter17;
        list-style-type: none
    }

    .awlist17 li:before {
        content: "17." counter(awlistcounter17);
        counter-increment: awlistcounter17
    }

    .awlist18 {
        counter-reset: awlistcounter18;
        list-style-type: none
    }

    .awlist18 li:before {
        content: "18." counter(awlistcounter18);
        counter-increment: awlistcounter18
    }

    .content {
        font-family: 华文楷体;
        font-size: 10.5pt;
        display: -moz-inline-box;
        display: inline-block;
        min-width: 15px;
        border-bottom: 1px solid #ff4a7d;
        min-height: 17px;
    }
    .content:focus {
        outline:none;
    }
</style>


// WEBPACK FOOTER //
// contract_4.vue?2508919a